import { Component, Vue } from "vue-property-decorator";
import { INavRoute, IRoute } from "@/@types/routes/routes";
import { getPermitions, getRootPermition } from "@/services/accessDecoder";
import routes from "@/router/modules/routes-list";

@Component({})
export default class GetRoutes extends Vue {
  routes: IRoute[] = [];
  navbarRoutes: INavRoute[] = [];

  async getFullRoutes(permissions: string[]): Promise<IRoute[]> {
    const routeList: IRoute[] = [];
    const root = getRootPermition();
    for (const route of routes) {
      if (!route.meta) continue;

      if (route.children && route.children.length) {
        const childrens: string[] = [];
        for (const child of route.children) {
          if (!child.meta || !child.name) continue;
          if (permissions.includes(child.meta.code) || root)
            childrens.push(child.name);
        }
        if (!childrens.length) continue;
        routeList.push({
          name: route.meta.name,
          children: childrens,
        });
      } else {
        if (!route.meta.code) continue;
        if (
          route.meta.code == "0" ||
          permissions.includes(route.meta.code) ||
          root
        )
          routeList.push({
            name: route.name ? route.name : "",
            children: [],
          });
      }
    }
    return routeList;
  }

  async startGetRoutes(): Promise<void> {
    this.routes = await this.getFullRoutes(getPermitions());
    this.$store.dispatch("ACTION_CHANGE_ROUTER", this.routes);
  }
}
